import {
  showNotification,
  showUploadStatus,
  setSourceUploadStatus
} from '@shoflo/studio-redux/actions';
import { handleMultipartUpload } from '@shoflo/studio-redux/utils';
import { withCurrentParams, handleDocumentUpload } from 'actions/utils';
import { BROADCAST_CREATE_CONTENT_SOURCE } from '@shoflo/studio-redux/actions/types';
import { UPLOADING } from 'constants/SourceUploadStatus';
import { isVideoSource } from 'utils/broadcastSourceHelper';
import onFailedUpload from './onFailedUpload';
import { SOURCE_CREATE_ERROR } from '@studio/constants';
import { SOURCE_MAX_FILE_SIZE_MULTIPART } from '@shoflo/polymer';
import { shouldHaveFeature } from '@studio/feature.flags';
/**
 * This function supports uploads only via S3 Proxy service.
 * Any changes in the upload functionality triggered from {@link MEDIA_SOURCE_FORM} Modal
 * opened by clicking Upload Content should be handled here.
 * @param {*} source
 * @param {*} isInitializing boolean value to set initializing state for sources
 * @param {*} fileUploadActionTracker - Functions to track file upload action
 */
const createContentSource = (
  source,
  isInitializing = false,
  fileUploadActionTracker
) => {
  return withCurrentParams((dispatch, { teamId, eventId, broadcastId }) => {
    // Don't attempt to create the action when source type is undefined
    if (!source.type) {
      return dispatch(
        showNotification(SOURCE_CREATE_ERROR, {
          type: 'warning'
        })
      );
    }

    const action = {
      type: BROADCAST_CREATE_CONTENT_SOURCE,
      request: async apiClient => {
        const { name: fileName = '' } = source.value || {};

        let payload = { ...source };

        /**
         * Since, the source is of document type {@link DocSourceTypes} we need to create a new event doc
         * so we can assign it as the value in the source object
         */
        dispatch(setSourceUploadStatus(fileName, UPLOADING));
        dispatch(showUploadStatus());

        const isMultiPartUploadEnabled = shouldHaveFeature(
          'studio.multipartupload'
        );

        const isMultiPartUpload =
          isMultiPartUploadEnabled &&
          isVideoSource(source) &&
          source.value.size > SOURCE_MAX_FILE_SIZE_MULTIPART;

        const createDocPayload = {
          name: fileName,
          description: 'Media Content',
          isStudioMedia: true,
          isMultipartUpload: isMultiPartUpload
        };
        const onFailedUploadCallback = onFailedUpload(dispatch, fileName);
        try {
          let eventDocumentId;
          if (isMultiPartUpload) {
            const uploadResponse = await handleMultipartUpload(
              apiClient,
              teamId,
              eventId,
              createDocPayload,
              source.value,
              fileUploadActionTracker.startFileUploadActionCallback
            );
            eventDocumentId = uploadResponse.eventDocId;
          } else {
            // For non-multipart uploads, we handle the document upload via S3 Proxy service
            const eventDocId = await handleDocumentUpload(
              apiClient,
              teamId,
              eventId,
              createDocPayload,
              source.value,
              fileUploadActionTracker.startFileUploadActionCallback
            );
            eventDocumentId = eventDocId;
          }
          payload.value = {
            eventDocId: eventDocumentId,
            ...(isVideoSource(source) && {
              transcodingStatus: 'processing'
            })
          };

          let result = await apiClient.broadcast.createSource(
            teamId,
            eventId,
            broadcastId,
            payload
          );
          // End file upload action tracker
          fileUploadActionTracker.endFileUploadActionCallback?.({});
          return {
            ...result,
            isInitializing
          };
        } catch (error) {
          console.error('Failed while uploading the file' + error);
          fileUploadActionTracker.endFileUploadActionCallback?.({
            errorMessage: error.message
          });
          onFailedUploadCallback();
          throw error;
        }
      }
    };
    dispatch(action);
  });
};

export default createContentSource;
